// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */
.Sidebar_sidebar__p35pD {
  width: 50px;
  height: 100vh;
  background-color: rgb(242, 241, 241);
  color: #111;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 20px; */
  transition: width 0.3s;
  background: #fbfcfe;
  z-index: 500;
  position: fixed;
  top: 50px;
  box-shadow: var(--Elevation-X-Elevation-04, 4px)
    var(--Elevation-Y-Elevation-04, 0px)
    var(--Elevation-Blur-Elevation-04, 24px)
    var(--Elevation-Spread-Elevation-04, -2px)
    var(--Elevation-Colors-Elevation-04, rgba(0, 92, 188, 0.08));
}

.Sidebar_sidebar__p35pD.Sidebar_expanded__E1I2Q {
  width: 150px;
  /* Expanded width */
}

.Sidebar_sidebarItem__tDID4 {
  width: inherit;
  /* padding: 15px; */
  padding: 10px 0px 10px 0px;
  /* text-align: center; */
  cursor: pointer;
  /* transition: padding 0.3s; */
  display: flex;
}

.Sidebar_sidebarItem__tDID4 span {
  /* padding-left: 10px; */
  /* border-left: 5px solid #005CBC; */
  /* width: 90%; */
  /* float: right; */
  padding-left: 15px;
  display: flex;
  align-items: center;
}

.Sidebar_sidebarItem__tDID4:hover {
  background-color: #f5f2f2;

}

.Sidebar_sidebarItemActive__NWIpn {
  border-left: 8px solid #005cbc;
  margin-right: 5px;
}

@media screen and (max-width: 500px) {
  .Sidebar_sidebar__p35pD {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/Components/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,SAAS;EACT;;;;gEAI8D;AAChE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Sidebar.css */\n.sidebar {\n  width: 50px;\n  height: 100vh;\n  background-color: rgb(242, 241, 241);\n  color: #111;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding-top: 20px; */\n  transition: width 0.3s;\n  background: #fbfcfe;\n  z-index: 500;\n  position: fixed;\n  top: 50px;\n  box-shadow: var(--Elevation-X-Elevation-04, 4px)\n    var(--Elevation-Y-Elevation-04, 0px)\n    var(--Elevation-Blur-Elevation-04, 24px)\n    var(--Elevation-Spread-Elevation-04, -2px)\n    var(--Elevation-Colors-Elevation-04, rgba(0, 92, 188, 0.08));\n}\n\n.sidebar.expanded {\n  width: 150px;\n  /* Expanded width */\n}\n\n.sidebarItem {\n  width: inherit;\n  /* padding: 15px; */\n  padding: 10px 0px 10px 0px;\n  /* text-align: center; */\n  cursor: pointer;\n  /* transition: padding 0.3s; */\n  display: flex;\n}\n\n.sidebarItem span {\n  /* padding-left: 10px; */\n  /* border-left: 5px solid #005CBC; */\n  /* width: 90%; */\n  /* float: right; */\n  padding-left: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.sidebarItem:hover {\n  background-color: #f5f2f2;\n\n}\n\n.sidebarItemActive {\n  border-left: 8px solid #005cbc;\n  margin-right: 5px;\n}\n\n@media screen and (max-width: 500px) {\n  .sidebar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__p35pD`,
	"expanded": `Sidebar_expanded__E1I2Q`,
	"sidebarItem": `Sidebar_sidebarItem__tDID4`,
	"sidebarItemActive": `Sidebar_sidebarItemActive__NWIpn`
};
export default ___CSS_LOADER_EXPORT___;
